import { Controller } from "@hotwired/stimulus"

// Closes a <dialog> when the click lands on the dialog surface itself —
// i.e. anywhere outside the panel content (children swallow their own
// clicks). The el-dialog backdrop is inert by design, so outside clicks
// fall through to the full-viewport transparent dialog element.
export default class extends Controller<HTMLDialogElement> {
  dismiss(event: MouseEvent) {
    if (event.target === this.element) this.element.close()
  }
}
